var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 5.75a6.25 6.25 0 1 0 5.677 8.867q-.57.132-1.177.133a5.25 5.25 0 0 1-3.722-8.952A6 6 0 0 0 12 5.75M4.25 12a7.75 7.75 0 0 1 9.316-7.592c.585.12.893.595.95 1.041a1.38 1.38 0 0 1-.465 1.211 3.75 3.75 0 0 0 3.565 6.421 1.38 1.38 0 0 1 1.274.245c.35.284.59.795.383 1.356A7.75 7.75 0 0 1 4.25 12",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.445 5.26a1.25 1.25 0 0 1 2.11 0l.46.724.725.461a1.25 1.25 0 0 1 0 2.11l-.724.46-.461.725a1.25 1.25 0 0 1-2.11 0l-.46-.724-.725-.461a1.25 1.25 0 0 1 0-2.11l.724-.46zM18.5 6.397l-.28.44a1.25 1.25 0 0 1-.383.383l-.44.28.44.28c.154.098.285.229.383.383l.28.44.28-.44a1.25 1.25 0 0 1 .383-.383l.44-.28-.44-.28a1.25 1.25 0 0 1-.383-.383z",
    clipRule: "evenodd"
  })));
};
export default SvgMoon;